import type { ApprovalResult } from '../../../../generated-types';
import { payCrossBorderPayment } from '../../../../services/crossBorderPaymentsService';
import createCrossBorderPaymentRequest from '../../../../utils/mapper/createCrossBorderPaymentRequest';
import { CrossBorderPaymentState } from './state';

type CrossBorderPaymentStateWithAdditionalInfo = {
    acceptDuplicate?: boolean;
    ignorePbdWarning?: boolean;
    ignoreSepaWarning?: boolean;
} & CrossBorderPaymentState;

export default ({
    acceptDuplicate,
    ignorePbdWarning,
    ignoreSepaWarning,
    ...crossBorderPaymentState
}: CrossBorderPaymentStateWithAdditionalInfo): Promise<ApprovalResult> => {
    const request = createCrossBorderPaymentRequest(crossBorderPaymentState);

    return payCrossBorderPayment(request, acceptDuplicate, ignorePbdWarning, ignoreSepaWarning);
};
